<template>
  <el-tabs v-model="activeOSTab" v-if="osSupportListReqStatus === 'saved'" @tab-click="changeOsType">
    <el-tab-pane class="full-height" label="Linux" name="linux">
      <span slot="label"> <i class="fab fa-linux"></i> Linux </span>
      <el-tabs type="card" v-model="linuxVersionTab" :tab-position="'left'" @tab-click="changeOsVersion">
        <el-tab-pane
          class="full-height"
          v-for="(os, idx) in sortByNameVersion(osSupportList['Linux'])"
          :key="idx"
          :name="`${os.os_name.toLowerCase()} ${os.os_version.toLowerCase()}`"
        >
          <span slot="label">
            <i class="`fab fa-${os.os_name.toLowerCase()}`"></i>
            {{ os.os_name }} {{ os.os_version }}
          </span>
          <vue-scroll class="full-height">
            <amazon-linux1-instructions
              v-if="os.os_name === 'Amazon Linux' && os.os_version === '1'"
              :environment="networkInfo.environment"
              :customer-name="networkInfo.customer_name"
              :version="networkInfo.agent_version"
              :os="os"
            ></amazon-linux1-instructions>
            <amazon-linux2-instructions
              v-if="os.os_name === 'Amazon Linux' && os.os_version === '2'"
              :environment="networkInfo.environment"
              :customer-name="networkInfo.customer_name"
              :version="networkInfo.agent_version"
              :os="os"
            ></amazon-linux2-instructions>
            <centos-instructions
              v-if="os.os_name === 'CentOS'"
              :environment="networkInfo.environment"
              :customer-name="networkInfo.customer_name"
              :version="networkInfo.agent_version"
              :os="os"
            ></centos-instructions>
            <redhat-instructions
              v-if="os.os_name === 'RHEL' && os.os_version.toLowerCase() !== 'compatible'"
              :environment="networkInfo.environment"
              :customer-name="networkInfo.customer_name"
              :version="networkInfo.agent_version"
              :os="os"
            ></redhat-instructions>
            <redhat-compatible-instructions
              v-if="os.os_name === 'RHEL' && os.os_version.toLowerCase() === 'compatible'"
              :environment="networkInfo.environment"
              :customer-name="networkInfo.customer_name"
              :version="networkInfo.agent_version"
              :os="os"
            ></redhat-compatible-instructions>
            <ubuntu-instructions
              v-if="os.os_name === 'Ubuntu'"
              :environment="networkInfo.environment"
              :customer-name="networkInfo.customer_name"
              :version="networkInfo.agent_version"
              :os="os"
            ></ubuntu-instructions>
          </vue-scroll>
        </el-tab-pane>
      </el-tabs>
    </el-tab-pane>
    <el-tab-pane class="full-height" label="Windows" name="windows">
      <span slot="label"> <i class="fab fa-windows"></i> Windows </span>
      <el-tabs type="card" v-model="windowsVersionTab" :tab-position="'left'" @tab-click="changeOsVersion">
        <el-tab-pane
          class="full-height"
          v-for="(os, idx) in sortByNameVersion(osSupportList['Windows'])"
          :key="idx"
          :name="`${os.os_name.toLowerCase()} ${os.os_version.toLowerCase()}`"
        >
          <span slot="label">
            <i class="`fab fa-${os.os_name.toLowerCase()}`"></i>
            {{ os.os_name }} {{ os.os_version }}
          </span>
          <vue-scroll class="full-height">
            <windows-instructions
              :environment="networkInfo.environment"
              :customer-name="networkInfo.customer_name"
              :version="networkInfo.agent_version"
              :os="os"
            ></windows-instructions>
          </vue-scroll>
        </el-tab-pane>
      </el-tabs>
    </el-tab-pane>
    <el-tab-pane class="full-height" label="Kubernetes" name="kubernetes">
      <span slot="label">
        Kubernetes
      </span>
      <vue-scroll class="full-height">
        <kubernetes-instructions></kubernetes-instructions>
      </vue-scroll>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeaders from '@/components/layout/PageHeaders.vue'

import { NETWORK_INFO_REQ, NETWORK_INFO_SUCCESS } from '@/store/modules/network_info/network-info.type'

import { OS_SUPPORT_LIST_REQ, OS_SUPPORT_LIST_SUCCESS } from '@/store/modules/os_support/os-support.type'

import { OS_DOWNLOAD_PROGRESS_SET } from '@/store/modules/os_support/os-support.type'

import {
  AmazonLinux1Instructions,
  AmazonLinux2Instructions,
  CentosInstructions,
  RedhatInstructions,
  RedhatCompatibleInstructions,
  UbuntuInstructions,
  WindowsInstructions,
  KubernetesInstructions
} from '@/components/os-template'

export default {
  name: 'InstallationAgent',
  data () {
    return {
      breadcrumbs: [{ title: 'Home' }, { title: 'Installation' }],
      activeOSTab: 'linux',
      linuxVersionTab: 'amazon linux 2',
      windowsVersionTab: 'windows server 2012r2'
    }
  },
  methods: {
    changeOsType (tab, event) {
      if (tab.name === 'kubernetes') {
        this.$router.replace({
          query: {
            os: tab.name
          }
        })
      } else if (tab.name === 'linux') {
        this.$router.replace({
          query: {
            os: tab.name,
            version: this.linuxVersionTab
          }
        })
      } else {
        this.$router.replace({
          query: {
            os: tab.name,
            version: this.windowsVersionTab
          }
        })
      }
      this.$store.dispatch(OS_DOWNLOAD_PROGRESS_SET, {
        percentage: 0,
        status: ''
      })
    },
    changeOsVersion (tab, event) {
      if (this.activeOSTab === 'linux') {
        this.$router.replace({
          query: {
            os: this.activeOSTab,
            version: tab.name
          }
        })
      } else {
        this.$router.replace({
          query: {
            os: this.activeOSTab,
            version: tab.name
          }
        })
      }
      this.$store.dispatch(OS_DOWNLOAD_PROGRESS_SET, {
        percentage: 0,
        status: ''
      })
    },
    sortByNameVersion(arrays) {
      return _.sortBy(arrays, (os) => { return os.os_name + os.os_version });
    }
  },
  created () {
    Promise.all([this.$store.dispatch(NETWORK_INFO_REQ), this.$store.dispatch(OS_SUPPORT_LIST_REQ)])
  },
  beforeMount () {
    // If window refreshed, stay on previous rules page
    if (!_.isEmpty(this.$route.query)) {
      if (!_.isEmpty(this.$route.query.os)) {
        this.$set(this, 'activeOSTab', this.$route.query.os.toLowerCase())
      }
      if (!_.isEmpty(this.$route.query.version)) {
        if (this.activeOSTab === 'linux') {
          this.$set(this, 'linuxVersionTab', this.$route.query.version.toLowerCase())
        } else {
          this.$set(this, 'windowsVersionTab', this.$route.query.version.toLowerCase())
        }
      }
    } else {
      this.$router.push({
        name: 'install-agent',
        query: { os: 'linux', version: 'amazon linux 2' }
      })
    }
    this.$store.dispatch(OS_DOWNLOAD_PROGRESS_SET, {
      percentage: 0,
      status: ''
    })
  },
  computed: {
    ...mapGetters(['networkInfo', 'osSupportList', 'osSupportListReqStatus'])
    // os () {
    //   if (this.$route.query) {
    //     return this.$route.query.os.toLowerCase()
    //   }
    //   return ''
    // }
  },
  components: {
    PageHeaders,
    AmazonLinux1Instructions,
    AmazonLinux2Instructions,
    CentosInstructions,
    RedhatInstructions,
    RedhatCompatibleInstructions,
    UbuntuInstructions,
    WindowsInstructions,
    KubernetesInstructions
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/text.css';

.network-req {
  > span {
    border-bottom: 1px solid var(--border-color);
    padding: 8px 0px;

    &:last-of-type {
      margin-bottom: 24px;
    }
  }
}

pre {
  white-space: pre-line;
}

.fab {
  font-size: 1.5em;
  vertical-align: middle;
}

.icon-logo {
  display: inline-block;
  height: 21px;
  width: 18px;
  background: #495057;
  mask-size: contain;
  mask-repeat: no-repeat;
  vertical-align: middle;
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

>>> .el-tabs {
  height: calc(100% - 100px);
}

>>> .el-tabs__content {
  height: 100%;
}

>>> .el-tabs__nav.is-left {
  border: none;

  .el-tabs__item {
    border: none !important;
    border-radius: unset;
    padding-left: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/installation/InstallationAgent.vue